export const foxityFilms = {
    name: 'Foxity Films',
    logo: {
        path: 'partners/foxity-films-logo-white.svg',
        alt: 'Foxity films logo',
    },
};
